export default "__VITE_ASSET__ed95f96d__"